/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React, { ReactElement, SyntheticEvent } from "react";
import styled from "styled-components";

import Level from "./Level";

type Option = {
  label: string;
  value: string;
};
interface WrapperProps {
  submitting: boolean;
}

interface LevelsProps {
  options: Option[];
  handleChange: (values: Option[] | Option, position: number) => void;
  levels: Array<Option[]>;
  errors: {
    name?: Array<string>;
  };
  touched: {
    name?: boolean;
  };
  handleInputChange: (
    selectedValues: Option[],
    position: number,
    action: object
  ) => void;
  handleBlur: (event: SyntheticEvent<HTMLElement>, name: string) => void;
  handleAddLevel: () => void;
  handleRemoveLevel: (number) => void;
  submitting: boolean;
}

const StyledLevelsWrapper = styled.div`
  padding: 5px 30px 20px 30px;
  ${(p: WrapperProps): string => {
    return (
      p.submitting &&
      `
    pointer-events: none;
    opacity: 0.7;
  `
    );
  }}
`;

const Levels = ({
  options,
  handleChange,
  levels,
  errors,
  touched,
  handleInputChange,
  handleBlur,
  handleAddLevel,
  handleRemoveLevel,
  submitting,
}: LevelsProps): ReactElement => {
  return (
    <StyledLevelsWrapper submitting={submitting}>
      <p>
        <b>
          You can add multiple approvers and up to four approval levels{" "}
        </b>
      </p>
      <p>
        <small>
          Use this for spot bonuses, sales awards, or larger one-time bonuses
          that require multiple levels of approval.
        </small>
      </p>
      {levels?.length
        ? levels.map((level, index) => {
            const position = index + 1;
            const buttonIsDisabled =
              !touched[`level_${position}`] ||
              (errors[`level_${position}`] &&
                errors[`level_${position}`].length) ||
              submitting;
            return (
              <div key={index}>
                <Level
                  options={options}
                  defaultOptions={level}
                  handleChange={handleChange}
                  handleInputChange={handleInputChange}
                  selectedOptions={level}
                  position={position}
                  totalLevels={levels.length}
                  errors={errors}
                  handleBlur={handleBlur}
                  disabled={submitting}
                  handleRemoveLevel={handleRemoveLevel}
                />
                {index === levels.length - 1 && (
                  <p>
                    <small>
                      When there are multiple approvers in a level, only one
                      person has to review a request in order for it to be
                      approved.
                    </small>
                  </p>
                )}
                {index < 3 && index === levels.length - 1 && (
                  <button
                    onClick={handleAddLevel}
                    className="cta-btn btn btn-secondary"
                    type="button"
                    disabled={buttonIsDisabled}
                  >
                    <b>Add Approval Level</b>
                  </button>
                )}
              </div>
            );
          })
        : null}
    </StyledLevelsWrapper>
  );
};

export default Levels;
